<template>
  <div class="content-section-div">
    <div class="tests-header">
      <div class="filters">
        <template v-if="viewTabIndex === 0">
          <div class="filter-group">
            <SelectBoxLabelled
                v-model="selectedItem"
                :label="getSelectBoxLabel"
                :dataType="tabType"
                :useBackend="true"
                :maxDropdownHeight="150"
                :searchable="true"
                @update:modelValue="handleItemSelectionChange"
                @optionsLoaded="handleOptionsLoaded"
                @selectionChanged="handleSelectionChanged"
            />
          </div>
          <div class="filter-group">
            <TimeSelectbox
                v-model="selectedTime"
                :label="$t('time')"
                @update:modelValue="updateSelectedTime"
            />
          </div>
        </template>

        <template v-else>
          <div class="filter-group">
            <div class="select-wrapper">
              <QuestionSelectBox
                  v-model="selectedQuestionCount"
                  :label="$t('reports.number_of_questions')"
                  :tabType="tabType"
                  @update:modelValue="handleQuestionCountChange"
                  @filterChange="handleQuestionFilterChange"
                  @optionsLoaded="handleQuestionOptionsLoaded"
              />
            </div>
          </div>

          <div class="filter-group">
            <div class="select-wrapper">
              <StatusSelectBox
                  v-model="selectedStatus"
                  :label="$t('status_payment')"
                  :tabType="tabType"
                  @update:modelValue="handleStatusChange"
              />
            </div>
          </div>

          <div class="filter-group">
            <div class="select-wrapper">
              <CompletionSelectBox
                  v-model="selectedCompletion"
                  :label="$t('reports.completion_two')"
                  :tabType="tabType"
                  @update:modelValue="handleCompletionChange"
                  @filterChange="handleCompletionFilterChange"
                  @optionsLoaded="handleCompletionOptionsLoaded"
              />
            </div>
          </div>

          <div class="filter-group">
            <div class="select-wrapper">
              <CreationSelectBox
                  v-model="selectedCreation"
                  :label="$t('creation_time')"
                  :tabType="tabType"
                  @update:modelValue="handleCreationChange"
                  @filterChange="handleCreationFilterChange"
                  @optionsLoaded="handleCreationOptionsLoaded"
              />
            </div>
          </div>
        </template>

      </div>

      <div class="view-options">
        <div class="view-tab-container">
          <button class="view-tab-button" :class="{'active': viewTabIndex === 0}" @click="() => changeViewTab(0)">
            <span>{{$t('by_user')}}</span>
          </button>
          <button class="view-tab-button" :class="{'active': viewTabIndex === 1}" @click="() => changeViewTab(1)">
            <span>{{$t('according_to_features')}}</span>
          </button>
        </div>
        <button class="btn-report" @click="requestReportDownload" :disabled="isPdfGenerating">
          <VueSpinnerIos v-if="isPdfGenerating" color="#ffffff" size="12px" />
          <template v-else>
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.0507817 6.12502C0.0505046 5.62797 0.176971 5.13907 0.41823 4.7045C0.659488 4.26994 1.00757 3.90407 1.42958 3.64147C1.54096 2.77301 1.96499 1.97489 2.62231 1.39649C3.27964 0.818081 4.12521 0.499023 5.00078 0.499023C5.87635 0.499023 6.72192 0.818081 7.37925 1.39649C8.03657 1.97489 8.4606 2.77301 8.57198 3.64147C9.09543 3.96713 9.50261 4.44985 9.73536 5.02071C9.96812 5.59157 10.0146 6.22137 9.86805 6.8202C9.72153 7.41902 9.38956 7.95624 8.91954 8.35515C8.44951 8.75407 7.86546 8.99427 7.25078 9.04147L2.75078 9.05002C1.24058 8.92672 0.0507817 7.66492 0.0507817 6.12502ZM7.18238 8.14417C7.608 8.11144 8.0124 7.94505 8.3378 7.66876C8.66321 7.39247 8.89298 7.02041 8.99429 6.60572C9.0956 6.19104 9.06328 5.75495 8.90193 5.35974C8.74058 4.96453 8.45847 4.63041 8.09588 4.40512L7.73273 4.17877L7.67873 3.75487C7.59462 3.10403 7.27638 2.50609 6.78349 2.07281C6.29061 1.63952 5.65681 1.40055 5.00056 1.40055C4.3443 1.40055 3.71051 1.63952 3.21762 2.07281C2.72474 2.50609 2.4065 3.10403 2.32238 3.75487L2.26838 4.17877L1.90613 4.40512C1.54356 4.63038 1.26145 4.96446 1.10009 5.35963C0.938726 5.75481 0.906362 6.19087 1.00762 6.60553C1.10888 7.0202 1.33858 7.39226 1.66392 7.66858C1.98926 7.94491 2.39359 8.11136 2.81918 8.14417L2.89703 8.15002H7.10453L7.18238 8.14417ZM5.45078 5.00002H6.80078L5.00078 7.25002L3.20078 5.00002H4.55078V3.20002H5.45078V5.00002Z" fill="white"/>
            </svg>
            {{$t('download_report')}}
          </template>
        </button>
      </div>
    </div>

    <div v-if="viewTabIndex === 0" class="reports-grid">
      <div class="report-card main-chart">
        <div class="card-header">
          <span>{{ assignedUsersLabel }}</span>
          <p class="date-range">{{ formattedDate }}</p>
        </div>
        <div class="chart-container">
          <div id="userLineChart" class="chart"></div>
        </div>
      </div>

      <div class="report-card pie-chart">
        <div class="card-header">
          <span>{{ genderLabel }}</span>
          <p class="date-range">{{ formattedDate }}</p>

        </div>
        <div class="chart-container">
          <div id="genderPieChart" class="chart"></div>
        </div>
      </div>

      <div class="bottom-charts-container">
        <div class="report-card bar-chart">
          <div class="card-header">
            <span>{{ rolesLabel }}</span>
            <p class="date-range">{{ formattedDate }}</p>
          </div>
          <div class="chart-container">
            <div id="userRolesChart" class="chart"></div>
          </div>
        </div>

        <div class="report-card donut-chart">
          <div class="card-header">
            <span>{{ departmentsLabel }}</span>
            <p class="date-range">{{ formattedDate }}</p>
          </div>
          <div class="chart-container">
            <div id="departmentDonutChart" class="chart"></div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="viewTabIndex === 1" class="reports-grid-2">
      <TestFeaturesTable
          v-if="tabType === 'test'"
          :loading="loading"
          :tests="tests"
          :fetch-tests="handleTestsStatusChange"
      ></TestFeaturesTable>

      <ProgramFeaturesTable
          v-else-if="tabType === 'program'"
          :programs="programData"
          :loading="programLoading"
          :fetch-programs="handleProgramsStatusChange"
      ></ProgramFeaturesTable>

      <UserFeaturesTable
          v-else-if="tabType === 'user'"
          :users="userData"
          :loading="userLoading"
          :fetch-users="handleUsersStatusChange"
      ></UserFeaturesTable>

      <GameLabFeaturesTable
          v-else-if="tabType === 'gameLabs'"
          :gameLabs="gameLabData"
          :loading="gameLabLoading"
          :fetch-game-labs="handleGameLabsStatusChange"
      ></GameLabFeaturesTable>
    </div>
  </div>
</template>

<script>
import {defineComponent, ref, onMounted, computed, watch, defineEmits, nextTick} from 'vue';
import SelectBoxLabelled from "@/components/SelectBoxLabelled.vue";
import TimeSelectBox from "@/components/TimeSelectBox.vue";
import TestFeaturesTable from "@/components/tables/Test/TestFeaturesTable.vue";
import ProgramFeaturesTable from "@/components/tables/Program/ProgramFeaturesTable.vue";
import UserFeaturesTable from "@/components/tables/User/UserFeaturesTable.vue";
import GameLabFeaturesTable from "@/components/tables/GameLab/GameLabFeaturesTable.vue";
import QuestionSelectBox from "@/components/QuestionSelectBox.vue";
import StatusSelectBox from "@/components/StatusSelectBox.vue";
import CompletionSelectBox from "@/components/CompletionSelectBox.vue";
import CreationSelectBox from "@/components/CreationSelectBox.vue";
import reportsService from "@/service/reportsService";
import ReportsFilters from "@/components/tables/Report/ReportsFilters.vue";
import {VueSpinnerIos} from 'vue3-spinners';
import {useI18n} from "vue-i18n";
import ApexCharts from 'apexcharts';
import {getCurrentInstance} from 'vue';

export default defineComponent({
  name: 'TabContent',

  components: {
    ReportsFilters,
    CreationSelectBox,
    TestFeaturesTable,
    ProgramFeaturesTable,
    UserFeaturesTable,
    GameLabFeaturesTable,
    QuestionSelectBox,
    StatusSelectBox,
    CompletionSelectBox,
    SelectBoxLabelled,
    TimeSelectbox: TimeSelectBox,
    VueSpinnerIos,
  },

  props: {
    tabType: {
      type: String,
      required: true
    },
    selectedTime: {
      type: String,
      default: 'week'
    },
    showCustomReport: {
      type: Boolean,
      default: false
    },
    isPdfGenerating: {
      type: Boolean,
      default: false
    }
  },

  emits: ['update:selectedTime', 'update:selectedItem', 'viewTabChanged', 'reportRequested', 'chartDataUpdated', 'chartDownloadRequested'],

  setup(props, { emit }) {
    const {t} = useI18n();
    const selectedItem = ref('all');
    const selectedTime = ref(props.selectedTime || 'week');
    const viewTabIndex = ref(0);

    const selectedQuestionCount = ref('all');
    const questionCountParams = ref(null);

    const selectedCompletion = ref('all');
    const completionParams = ref(null);

    const selectedCreation = ref('all');
    const creationParams = ref(null);

    const selectedStatus = ref(2);

    const loading = ref(0);
    const tests = ref([]);

    const programData = ref([]);
    const programLoading = ref(false);

    const userData = ref([]);
    const userLoading = ref(false);

    const gameLabData = ref([]);
    const gameLabLoading = ref(false);

    const isChartDataLoading = ref(false);

    const getSelectBoxLabel = computed(() => {
      switch(props.tabType) {
        case 'test': return t('tests');
        case 'program': return t('programs_title');
        case 'user': return t('users_button');
        case 'gameLabs': return t('gameLabs_title');
        default: return 'Seçim';
      }
    });

    const handleQuestionCountChange = (selectedValue) => {
      selectedQuestionCount.value = selectedValue;
    };

    const handleQuestionFilterChange = (filterData) => {
      questionCountParams.value = filterData.questionCount;

      if (viewTabIndex.value === 1) {
        applyFiltersToTable();
      }
    };

    const handleQuestionOptionsLoaded = (options) => {
    };

    const handleCompletionChange = (selectedValue) => {
      selectedCompletion.value = selectedValue;
    };

    const handleCompletionFilterChange = (filterData) => {
      completionParams.value = filterData.completion;

      if (viewTabIndex.value === 1) {
        applyFiltersToTable();
      }
    };

    const handleCompletionOptionsLoaded = (options) => {
    };

    const handleCreationChange = (selectedValue) => {
      selectedCreation.value = selectedValue;
    };

    const handleCreationFilterChange = (filterData) => {
      creationParams.value = filterData.creation;

      if (viewTabIndex.value === 1) {
        applyFiltersToTable();
      }
    };

    const handleCreationOptionsLoaded = (options) => {
    };

    const applyFiltersToTable = async () => {
      await fetchDataWithCurrentFilters();
    };

    const fetchDataWithCurrentFilters = async () => {
      if (props.tabType === 'test') {
        await handleTestsStatusChange(selectedStatus.value);
      } else if (props.tabType === 'program') {
        await handleProgramsStatusChange(selectedStatus.value);
      } else if (props.tabType === 'user') {
        await handleUsersStatusChange(selectedStatus.value);
      } else if (props.tabType === 'gameLabs') {
        await handleGameLabsStatusChange(selectedStatus.value);
      }
    };

    const handleItemSelectionChange = (selectedValue) => {
      selectedItem.value = selectedValue;
      emit('update:selectedItem', selectedValue);

      if (viewTabIndex.value === 0 && !props.showCustomReport) {
        updateChartDataWithFilter(selectedValue);
      }
    };

    const handleSelectionChanged = (selectionData) => {
      handleItemSelectionChange(selectionData.value);
    };

    const updateChartDataWithFilter = async (selectedItemId) => {
      if (isChartDataLoading.value) return;

      const instance = getCurrentInstance();
      const routeQuery = instance?.proxy?.$route?.query || {};

      let apiParams = {
        type: getApiType(),
        parameterType: 'users',
        period: selectedTime.value,
        status: 1,
        page: 1,
        limit: 20
      };

      if (routeQuery['created_at[start]']) {
        apiParams['created_at[start]'] = routeQuery['created_at[start]'];
      }

      if (routeQuery['created_at[end]']) {
        apiParams['created_at[end]'] = routeQuery['created_at[end]'];
      }

      if (selectedItemId && selectedItemId !== 'all') {
        switch(props.tabType) {
          case 'test':
            apiParams.testIds = [selectedItemId];
            break;
          case 'program':
            apiParams.programIds = [selectedItemId];
            break;
          case 'user':
            apiParams.userIds = [selectedItemId];
            break;
          case 'gameLabs':
            apiParams.gameLabsIds = [selectedItemId];
            break;
        }
      }

      try {
        isChartDataLoading.value = true;
        const response = await reportsService.getReportData(apiParams);

        if (response?.data?.data) {
          emit('chartDataUpdated', response.data);
        } else {
          emit('chartDataUpdated', { data: {} });
        }
      } catch (error) {
        emit('chartDataUpdated', { data: {} });
      } finally {
        isChartDataLoading.value = false;
      }
    };

    const getApiType = () => {
      const mapping = {
        test: 'selfAssessments',
        program: 'programs',
        user: 'users',
        gameLabs: 'gameLabs'
      };
      return mapping[props.tabType] || 'users';
    };

    const handleOptionsLoaded = (options) => {
    };

    const formattedDate = computed(() => {
      const today = new Date();
      const day = today.getDate();
      const month = today.getMonth();
      const year = today.getFullYear();

      const monthKey = `monthNames.${month}`;
      return `${day} ${t(monthKey)} ${year}`;
    });

    const title = computed(() => {
      switch(props.tabType) {
        case 'test': return 'Tests';
        case 'program': return 'Programs';
        case 'user': return 'Users';
        case 'gameLabs': return 'GameLabs';
        default: return 'Reports';
      }
    });

    const assignedUsersLabel = computed(() => {
      const labelKeys = {
        'test': 'assignedUserCount',
        'program': 'programRegisteredUsers',
        'user': 'userActivity',
        'gameLabs': 'gameLabUsers'
      };

      const key = labelKeys[props.tabType] || 'userCount';
      return t(key);
    });

    const genderLabel = computed(() => {
      const labelKeys = {
        'test': 'testStatusDistribution',
        'program': 'programStatusDistribution',
        'user': 'genderDistribution',
        'gameLabs': 'gameLabUsageDistribution'
      };

      const key = labelKeys[props.tabType] || 'distribution';
      return t(key);
    });

    const rolesLabel = computed(() => {
      const labelKeys = {
        'test': 'testTypes',
        'program': 'programTypes',
        'user': 'userRoles',
        'gameLabs': 'gameLabTypes'
      };

      const key = labelKeys[props.tabType] || 'categories';
      return t(key);
    });

    const departmentsLabel = computed(() => {
      const labelKeys = {
        'test': 'departmans',
        'program': 'programGroups',
        'user': 'departments',
        'gameLabs': 'gameLabCategories'
      };

      const key = labelKeys[props.tabType] || 'sections';
      return t(key);
    });

    const changeViewTab = (index) => {
      viewTabIndex.value = index;
      emit('viewTabChanged', index);
    };

    const updateSelectedTime = (newTime) => {
      selectedTime.value = newTime;
      emit('update:selectedTime', newTime);
    };

    const handleStatusChange = async (status) => {
      selectedStatus.value = status;

      if (viewTabIndex.value === 1) {
        if (props.tabType === 'test') {
          await handleTestsStatusChange(status);
        } else if (props.tabType === 'program') {
          await handleProgramsStatusChange(status);
        } else if (props.tabType === 'user') {
          await handleUsersStatusChange(status);
        } else if (props.tabType === 'gameLabs') {
          await handleGameLabsStatusChange(status);
        }
      }
    };

    const handleTestsStatusChange = async (status) => {
      loading.value = 1;

      try {
        const apiParams = {
          type: 'selfAssessments',
          parameterType: 'properties'
        };

        if (status !== 2 && status !== '2') {
          apiParams.status = status;
        }

        if (questionCountParams.value) {
          apiParams['questionCount[min]'] = questionCountParams.value.min;
          apiParams['questionCount[max]'] = questionCountParams.value.max;
        }

        if (completionParams.value) {
          apiParams['completion[min]'] = completionParams.value.min;
          apiParams['completion[max]'] = completionParams.value.max;
        }

        if (creationParams.value) {
          apiParams['created_at[start]'] = creationParams.value.start;
          apiParams['created_at[end]'] = creationParams.value.end;
        }

        const response = await reportsService.getReportData(apiParams);

        if (response.data.data) {
          tests.value = response.data.data;
        } else {
          tests.value = [];
        }

      } catch (error) {
        tests.value = [];
      } finally {
        loading.value = 0;
      }
    };

    const handleGameLabsStatusChange = async (status) => {
      gameLabLoading.value = true;

      try {
        const apiParams = {
          type: 'gameLabs',
          parameterType: 'properties'
        };

        if (status !== 2 && status !== '2') {
          apiParams.status = status;
        }

        if (questionCountParams.value) {
          apiParams['questionCount[min]'] = questionCountParams.value.min;
          apiParams['questionCount[max]'] = questionCountParams.value.max;
        }

        if (completionParams.value) {
          apiParams['completion[min]'] = completionParams.value.min;
          apiParams['completion[max]'] = completionParams.value.max;
        }

        if (creationParams.value) {
          apiParams['created_at[start]'] = creationParams.value.start;
          apiParams['created_at[end]'] = creationParams.value.end;
        }

        const response = await reportsService.getReportData(apiParams);

        if (response.data.data) {
          gameLabData.value = response.data.data;
        } else {
          gameLabData.value = [];
        }

      } catch (error) {
        gameLabData.value = [];
      } finally {
        gameLabLoading.value = false;
      }
    };

    const handleUsersStatusChange = async (status) => {
      userLoading.value = true;

      try {
        const apiParams = {
          type: 'users',
          parameterType: 'properties'
        };

        if (status !== 2 && status !== '2') {
          apiParams.status = status;
        }

        if (completionParams.value) {
          apiParams['completion[min]'] = completionParams.value.min;
          apiParams['completion[max]'] = completionParams.value.max;
        }

        if (creationParams.value) {
          apiParams['created_at[start]'] = creationParams.value.start;
          apiParams['created_at[end]'] = creationParams.value.end;
        }

        const response = await reportsService.getReportData(apiParams);

        if (response.data.data) {
          userData.value = response.data.data;
        } else {
          userData.value = [];
        }
      } catch (error) {
        userData.value = [];
      } finally {
        userLoading.value = false;
      }
    };

    const handleProgramsStatusChange = async (status) => {
      programLoading.value = true;

      try {
        const apiParams = {
          type: 'programs',
          parameterType: 'properties'
        };

        if (status !== 2 && status !== '2') {
          apiParams.status = status;
        }

        if (questionCountParams.value) {
          apiParams['questionCount[min]'] = questionCountParams.value.min;
          apiParams['questionCount[max]'] = questionCountParams.value.max;
        }

        if (completionParams.value) {
          apiParams['completion[min]'] = completionParams.value.min;
          apiParams['completion[max]'] = completionParams.value.max;
        }

        if (creationParams.value) {
          apiParams['created_at[start]'] = creationParams.value.start;
          apiParams['created_at[end]'] = creationParams.value.end;
        }

        const response = await reportsService.getReportData(apiParams);

        if (response.data.data) {
          programData.value = response.data.data;
        } else {
          programData.value = [];
        }

      } catch (error) {
        programData.value = [];
      } finally {
        programLoading.value = false;
      }
    };

    watch(() => {
      const instance = getCurrentInstance();
      return instance?.proxy?.$route?.query;
    }, (newQuery, oldQuery) => {
      if (!props.showCustomReport) {
        if (viewTabIndex.value === 0) {
          updateChartDataWithFilter(selectedItem.value);
        } else if (viewTabIndex.value === 1) {
          applyFiltersToTable();
        }
      }
    }, {
      deep: true,
      immediate: false
    });

    watch(selectedTime, async (newValue, oldValue) => {
      if (newValue === oldValue || isChartDataLoading.value) return;

      emit('update:selectedTime', newValue);

      if (newValue !== props.selectedTime && !props.showCustomReport) {
        isChartDataLoading.value = true;
        try {
          await updateChartDataWithFilter(selectedItem.value);
        } finally {
          isChartDataLoading.value = false;
        }
      }
    });

    watch(selectedItem, (newValue) => {
      emit('update:selectedItem', newValue);
    });

    watch(() => props.selectedTime, (newValue) => {
      selectedTime.value = newValue;
    });

    const getTableData = () => {
      switch(props.tabType) {
        case 'test':
          return tests.value;
        case 'program':
          return programData.value;
        case 'user':
          return userData.value;
        case 'gameLabs':
          return gameLabData.value;
        default:
          return [];
      }
    };

    const requestReportDownload = () => {
      emit('reportRequested', {
        type: props.tabType,
        item: selectedItem.value,
        time: selectedTime.value,
        questionCount: questionCountParams.value,
        completion: completionParams.value,
        creation: creationParams.value,
        viewTab: viewTabIndex.value,
        tableData: viewTabIndex.value === 1 ? getTableData() : null
      });
    };

    const downloadChart = (chartId) => {
      emit('chartDownloadRequested', chartId);
    };

    onMounted(async () => {
      if (viewTabIndex.value === 0) {
        await updateChartDataWithFilter(selectedItem.value);
      } else {
        await fetchDataWithCurrentFilters();
      }
    });

    return {
      selectedItem,
      selectedTime,
      viewTabIndex,
      title,
      tests,
      programData,
      programLoading,
      userData,
      userLoading,
      gameLabData,
      gameLabLoading,
      formattedDate,
      assignedUsersLabel,
      genderLabel,
      rolesLabel,
      departmentsLabel,
      changeViewTab,
      updateSelectedTime,
      requestReportDownload,
      handleTestsStatusChange,
      handleProgramsStatusChange,
      handleUsersStatusChange,
      handleGameLabsStatusChange,
      handleStatusChange,
      selectedQuestionCount,
      questionCountParams,
      handleQuestionCountChange,
      handleQuestionFilterChange,
      handleQuestionOptionsLoaded,
      applyFiltersToTable,
      selectedCompletion,
      completionParams,
      handleCompletionChange,
      handleCompletionFilterChange,
      handleCompletionOptionsLoaded,
      selectedCreation,
      creationParams,
      handleCreationChange,
      handleCreationFilterChange,
      handleCreationOptionsLoaded,
      selectedStatus,
      getSelectBoxLabel,
      handleItemSelectionChange,
      handleSelectionChanged,
      handleOptionsLoaded,
      updateChartDataWithFilter,
      getApiType,
      isChartDataLoading,
      downloadChart,
      getTableData,
      loading,
      fetchDataWithCurrentFilters
    };
  }
});
</script>

<style scoped>
.content-section-div {
  border-radius: 6px;
  flex-direction: column;
  width: 100%;
}

.tests-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  width: 100%;
  gap: 16px;
}

.tests-header h2 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.filters {
  display: flex;
  gap: 8px;
  align-items: center;
  flex: 1;
  min-width: 0;
  order: 1;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.btn-filter-wrapper {
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}

.filter-group label {
  font-size: 13px;
  color: #555;
}

.select-wrapper {
  position: relative;
}

.select-wrapper select {
  appearance: none;
  background: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 8px 28px 8px 12px;
  font-size: 12px;
  cursor: pointer;
}

.select-wrapper::after {
  content: '';
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  pointer-events: none;
}

.view-options {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-shrink: 0;
  white-space: nowrap;
  order: 2;
}

.view-tab-container {
  display: flex;
  background: #F3F4F6;
  border-radius: 8px;
  overflow: hidden;
  height: 40px;
  justify-content: center;
  align-items: center;
  padding: 4px;
  flex-shrink: 0;
}

.view-tab-container span {
  color: #374151;
  font-size: 11px !important;
  font-family: 'euclid_medium', sans-serif;
  font-weight: 500;
}

.view-tab-button {
  padding: 0 16px;
  height: 32px;
  border: none;
  background: transparent;
  font-family: 'euclid_medium', sans-serif;
  font-size: 11px;
  color: #6B7280;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.view-tab-button.active {
  background: #ffffff;
  color: #374151;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.btn-report {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #111827;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  height: 40px;
  white-space: nowrap;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.btn-report:hover {
  background: #1F2937;
}

.reports-grid {
  display: grid;
  grid-template-columns: 60% 40%;
  grid-template-rows: 1fr 1fr;
  gap: 20px;
  width: 100%;
  margin-top: 0;
  height: 800px;
}

.main-chart {
  grid-column: 1;
  grid-row: 1;
}

.pie-chart {
  grid-column: 2;
  grid-row: 1;
}

.bottom-charts-container {
  grid-column: 1 / 3;
  grid-row: 2;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.report-card {
  background: #ffffff;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  transition: all 0.2s ease;
}

.report-card:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
  border-color: #D1D5DB;
}

.card-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 20px;
  min-height: 56px;
  position: relative;
}

.card-header span {
  font-size: 13px;
  color: #374151;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: 'Euclid Circular  A', sans-serif;
}

.date-range {
  font-size: 11px;
  color: #9CA3AF;
  font-weight: 400;
  font-family: 'Inter', sans-serif;
  margin: 0;
}

.card-actions {
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  gap: 8px;
  align-items: center;
}

.card-actions svg {
  width: 16px;
  height: 16px;
  padding: 4px;
  background: #F5F5F5;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-sizing: content-box;
  width: 24px;
  height: 16px;
}

.card-actions svg:hover {
  background: #E5E5E5;
  transform: scale(1.05);
}

.chart-container {
  flex: 1;
  padding: 16px 20px 20px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  position: relative;
}

.chart {
  width: 100%;
  height: 100%;
  position: relative;
}

.main-chart,
.pie-chart,
.bar-chart,
.donut-chart {
  height: 380px;
}

.main-chart .chart-container {
  height: 324px;
}

.pie-chart .chart-container,
.bar-chart .chart-container,
.donut-chart .chart-container {
  height: 324px;
}

#userLineChart,
#genderPieChart,
#userRolesChart,
#departmentDonutChart {
  background: transparent;
  width: 100%;
  height: 100%;
}

.apexcharts-gridlines-horizontal line {
  stroke: #F3F4F6 !important;
  stroke-width: 0.5 !important;
  stroke-dasharray: 0 !important;
}

.apexcharts-gridlines-vertical line {
  stroke: #F3F4F6 !important;
  stroke-width: 0.5 !important;
  stroke-dasharray: 0 !important;
}

.apexcharts-pie-slice path {
  filter: none !important;
}

.apexcharts-pie-slice:hover path {
  filter: brightness(1.05) !important;
}

.chart-loading::before {
  content: '';
  width: 16px;
  height: 16px;
  border: 2px solid #E5E7EB;
  border-top: 2px solid #3B82F6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 6px;
}

.chart-empty svg {
  width: 40px;
  height: 40px;
  margin-bottom: 8px;
  opacity: 0.4;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 1024px) {
  .tests-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .filters {
    order: 1;
    justify-content: flex-start;
  }

  .view-options {
    order: 2;
    justify-content: space-between;
    width: 100%;
  }
}

@media (max-width: 1200px) {
  .filters {
    gap: 6px;
  }

  .filter-group {
    gap: 4px;
  }

  .reports-grid {
    gap: 16px;
    height: 560px;
  }

  .card-header {
    padding: 14px 18px;
    min-height: 52px;
  }

  .chart-container {
    padding: 14px 18px 18px 18px;
  }

  .main-chart .chart-container,
  .pie-chart .chart-container,
  .bar-chart .chart-container,
  .donut-chart .chart-container {
    height: 208px;
  }
}

@media (max-width: 992px) {
  .reports-grid {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, auto);
    gap: 16px;
    height: auto;
  }

  .main-chart,
  .pie-chart,
  .bar-chart,
  .donut-chart {
    grid-column: 1;
    grid-row: auto;
    min-height: 320px;
  }

  .main-chart .chart-container {
    height: 264px;
  }

  .pie-chart .chart-container,
  .bar-chart .chart-container,
  .donut-chart .chart-container {
    height: 264px;
  }
}

@media (max-width: 768px) {
  .tests-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .filters {
    flex-wrap: wrap;
    gap: 6px;
  }

  .view-options {
    width: 100%;
    justify-content: space-between;
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .view-tab-container,
  .btn-report {
    width: 100%;
    justify-content: center;
  }

  .filter-group {
    gap: 4px;
  }

  .card-header {
    padding: 12px 16px;
    min-height: 48px;
  }

  .card-header span {
    font-size: 12px;
  }

  .date-range {
    font-size: 10px;
  }

  .chart-container {
    padding: 12px 16px 16px 16px;
  }

  .main-chart .chart-container,
  .pie-chart .chart-container,
  .bar-chart .chart-container,
  .donut-chart .chart-container {
    height: 240px;
  }

  .reports-grid {
    gap: 12px;
  }

  .main-chart,
  .pie-chart,
  .bar-chart,
  .donut-chart {
    min-height: 300px;
  }
}

:deep(.dropdown-menu),
:deep(.dropdown-options),
:deep(.select-options),
:deep(.tests-dropdown .dropdown-menu) {
  max-height: 150px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;

  scrollbar-width: thin !important;
  scrollbar-color: #ddd #f9f9f9 !important;
}

:deep(.dropdown-menu::-webkit-scrollbar),
:deep(.dropdown-options::-webkit-scrollbar),
:deep(.select-options::-webkit-scrollbar),
:deep(.tests-dropdown .dropdown-menu::-webkit-scrollbar) {
  width: 3px !important;
}

:deep(.dropdown-menu::-webkit-scrollbar-track),
:deep(.dropdown-options::-webkit-scrollbar-track),
:deep(.select-options::-webkit-scrollbar-track),
:deep(.tests-dropdown .dropdown-menu::-webkit-scrollbar-track) {
  background: transparent !important;
}

:deep(.dropdown-menu::-webkit-scrollbar-thumb),
:deep(.dropdown-options::-webkit-scrollbar-thumb),
:deep(.select-options::-webkit-scrollbar-thumb),
:deep(.tests-dropdown .dropdown-menu::-webkit-scrollbar-thumb) {
  background: #ddd !important;
  border-radius: 3px !important;
}

:deep(.dropdown-menu::-webkit-scrollbar-thumb:hover),
:deep(.dropdown-options::-webkit-scrollbar-thumb:hover),
:deep(.select-options::-webkit-scrollbar-thumb:hover),
:deep(.tests-dropdown .dropdown-menu::-webkit-scrollbar-thumb:hover) {
  background: #bbb !important;
}

:deep(.dropdown-portal-container) {
  z-index: 999999 !important;
}
</style>
